var map = {
	"./de-Latn-DE.json": "ebed",
	"./en-Latn-US.json": "37dc",
	"./en.json": "edd4",
	"./es-Latn-ES.json": "f453",
	"./es.json": "a306",
	"./fr-Latn-FR.json": "95bc",
	"./id-Latn-ID.json": "7d67",
	"./ja-Jpan-JP.json": "742f",
	"./ja.json": "0423",
	"./pt-Latn-PT.json": "e659",
	"./yue-Hant-HK.json": "ce28",
	"./zh-HK.json": "5afa",
	"./zh-Hans-CN.json": "80d5",
	"./zh-Hant-HK.json": "623b",
	"./zh.json": "3504"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";